import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name noOfBlurCards
 * @description Get number of rate cards in rate json. 
 * if number od rate cards is zero, then show 2 blur cards in case of uuid request.
 *
 * @param {Object} seaFCLJSON - Full FCL rate json
 * @param {Object} seaLCLJSON - Full LCL rate json
 * @param {Object} airJSON - Full AIR rate json
 * @returns {number}
 *
 * @example
 * console.log(noOfBlurCards(seaFCLJSON, seaLCLJSON, airJSON)); //3
 */

// First array with at least one element. NOTE: an empty array is truthy, so a plain
// `fcl || lcl || air` picks fcl even when it is `[]` — which it always is for an LCL
// search (get_buying_rate seeds rates as { fcl: [], lcl: [...] }). That made noOfBlurCards
// return 0 for LCL, so the public rate-gate rendered zero blurred cards AND hid the unlock
// overlay → a blank results area. Select the first NON-empty array instead.
const firstNonEmptyArr = (...arrs) =>
  arrs.find((a) => Array.isArray(a) && a.length > 0) || [];

//no. of cards depends on rates item json,
export const noOfBlurCards = (seaFCLJSON, seaLCLJSON, airJSON) => {
  const jsonData =
    (!isEmpty(seaFCLJSON) && seaFCLJSON) ||
    (!isEmpty(seaLCLJSON) && seaLCLJSON) ||
    (!isEmpty(airJSON) && airJSON) ||
    {};
  const jsonRates = (!isEmpty(jsonData) && jsonData.rates) || {};
  const itemJsonArr = !isEmpty(jsonRates)
    ? firstNonEmptyArr(jsonRates.fcl, jsonRates.lcl, jsonRates.air)
    : [];

  let noOfCards = 0;

  if (isTypeUuid(jsonData)) {
    noOfCards = 2; //default no. of cards in case
    if (Array.isArray(itemJsonArr)) {
      noOfCards = itemJsonArr.length || 2;
    }
  } else {
    // if rate json is not uuid type
    noOfCards = 0; //default no. of cards in case
    if (Array.isArray(itemJsonArr)) {
      noOfCards = itemJsonArr.length;
    }
  }

  // console.log({ noOfCards });

  return noOfCards;
};

// is the rate json is uuid type or normal cards
const isTypeUuid = (jsonData = {}) => {
  let typeUuid = true;

  // if number of tries is zero then return
  let no_of_tries = Number(jsonData.no_of_tries);
  no_of_tries = isNaN(no_of_tries) ? 0 : no_of_tries;

  if (!jsonData.req_uuid) {
    typeUuid = false;
  } else if (no_of_tries === 0) {
    typeUuid = false;
  }

  return typeUuid;
};
